import type { HTMLAttributes } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

/** Platzhalter, solange Daten laden. (Ergänzung, nicht im Design System.) */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...rest} />;
}

/** Ladeanzeige für Buttons und kleine Bereiche. (Ergänzung, nicht im Design System.) */
export function Spinner({ size = 16, className, label = 'Lädt' }: { size?: number; className?: string; label?: string }) {
  return <Loader2 size={size} strokeWidth={1.75} role="status" aria-label={label} className={cn('animate-spin text-muted-foreground', className)} />;
}
